import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientSideAuthWrapper"] */ "/vercel/path0/web/frontend/src/components/ClientSideAuthWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VerticalMarquee"] */ "/vercel/path0/web/frontend/src/components/VerticalMarquee.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/asset-cost-v2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/authors/AaronSiegel.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/authors/AlanCruickshank.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/authors/AlexGoodwin.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/authors/DanCorcoran.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/authors/ErikWebb.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/authors/GarrettMcClintock.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/authors/GaryJames.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/authors/JessicaFranks.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/authors/JonathanTalmi.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/authors/MarcusWong.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/authors/PamelaDalal.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/authors/SeanAbraham.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/caret.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/cta-grain.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/dashboard.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/hero-grain.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/insights.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/integrations-mobile.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/integrations.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/notifications.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/savings.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/stars.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/usage-groups.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/images/visibility.png");
